/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, createContext } from "react";

interface ErrorResponseDto {
  error_code: string;
  errors: string[];
  message: string;
  status_code: number;
  title?: string;
}

interface AppContextState {
  errorResponse: ErrorResponseDto;
}

export interface AppContextValue {
  errorResponse: ErrorResponseDto;
  setErrorResponse: (value: any) => void;
}

export const AppContext = createContext<AppContextValue>({} as never);

const AppContextProvider = ({ children }) => {
  const [{ errorResponse }, updateState] = useState<AppContextState>({
    errorResponse: {
      error_code: "",
      errors: [],
      message: "",
      status_code: 0,
      title: "",
    },
  });

  const setErrorResponse = (error) => {
    updateState((prevState) => ({
      ...prevState,
      errorResponse: error,
    }));
  };

  return (
    <AppContext.Provider
      value={{
        errorResponse,
        setErrorResponse,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;
